import axios from 'axios'
import router from '../router'
import {
  Message
} from 'element-ui'
import { getCookieToken, isEmpty, removeToken } from '@/utils/tool'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    var isUk = false
    const origin = window.location.origin
    if (origin === 'https://gm.gayzd.com:18444') {
      isUk = true
    }
    if (isUk) {
      config.baseURL = 'https://gm.gayzd.com:18444/apis'
      if (config.url.startsWith('https://www.gayzd.com/apis')) {
        config.url = config.baseURL + config.url.substring(26)
      }
    }
    if (isEmpty(config.headers.Authorization)) {
      // do something before request is sent
      const token = getCookieToken()
      if (token) {
        // let each request carry token
        config.headers['Authorization'] = token
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
var num = 0
// response interceptor
service.interceptors.response.use(
  (response) => {
    // console.log('响应拦截器，正确')
    return response
  },
  (error) => {
    /* console.log('响应拦截器，错误')
    console.log(error.response.data.code) */
    // 重复登录

    /*  if(error.response.data.code=='010124'){
         num++
         if(num==1){
             console.log('pppp')
             // alert('账号已在别处登陆，请检查是否是本人授权，请重新登录')

             VueCookies.remove("yzd_token");
             VueCookies.remove("yzd_qyState");
             VueCookies.remove("isInit");
             router.push("/login")

             Message({
                 message:"账号已在别处登陆，请检查是否是本人授权，请重新登录" ,
                 type: 'error'
               });
         }
     }else if(error.response.data.code=='010119'){
         num2++
         if(num2==1){
             console.log('pppp')

             VueCookies.remove("yzd_token");
             VueCookies.remove("yzd_qyState");
             VueCookies.remove("isInit");
             router.push("/login")
             Message({
                 message:"登录超时，请重新登录" ,
                 type: 'error'
               });
         }
     }else if(error.response.data.code=='010123'||error.response.data.code=='010125'){
         VueCookies.remove("yzd_token");
             VueCookies.remove("yzd_qyState");
             VueCookies.remove("isInit");
             router.push("/login")
             Message({
                 message:error.response.data.mesg ,
                 type: 'error'
               });
     }  */
    if (error.response.config.responseType === 'blob') {
      const fileReader = new FileReader()
      fileReader.readAsText(error.response.data, 'utf-8')
      fileReader.onload = () => {
        const msg = JSON.parse(fileReader.result)
        Message({
          message: msg.mesg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(error)
    }
    var res = error.response.data
    if (res.code == '010119' ||
      res.code == '010120' ||
      res.code == '010124' ||
      res.code == '010121' ||
      res.code == '010123' ||
      res.code == '010125' ||
      res.mesg == 'token格式不正确') {
      num++
      if (num < 2) {
        removeToken()
        router.push('/login')
        Message({
          message: res.mesg,
          type: 'error',
          duration: 5 * 1000
        })
        setInterval(() => {
          num = 0
        }, 500)
        return Promise.reject(new Error(res.mesg || 'Error'))
      }
    } else if (res.code === '600003') {
      store.state.txjymShow = true
      return Promise.reject(error)
    }else {
      Message({
        message: error.response.data.mesg,
        type: 'error'
      })
      return Promise.reject(error)
    }
  }
)

export default service
